
type Props = {
  title: string;
  className?: string;
  type?: "primary" | "primary-light";
  onClick?: () => void;
  disabled?: boolean;
};

const RegularButton = (props: Props) => {
  return (
    <button
    disabled={props.disabled}
    onClick={props.onClick}
    className={`${props.className || ""} ${
      props.disabled
        ? "bg-gray-300 hover:bg-gray-300 text-black text-sm cursor-not-allowed"
        : props.type === "primary-light"
        ? "bg-blue-200 hover:bg-red-300 text-red-500"
        : "bg-[#ED1C24] hover:bg-red-600 text-white"
    } w-full py-1.5 rounded-full text-lg font-semibold shadow-lg transition-all whitespace-nowrap`}
  >
    {props.title}
  </button>
  );
};

export default RegularButton;
